// Get lan from local storage
const GCC_V2_LANGUAGE_KEY = "astriaGCCV2Language";

export type GCCV2Language = "en" | "ar";

export const getStoredGCCV2Language = (): GCCV2Language => {
  try {
    const value = localStorage.getItem(GCC_V2_LANGUAGE_KEY);
    return value === "ar" ? "ar" : "en";
  } catch {
    return "en";
  }
};

export const setStoredGCCV2Language = (lang: GCCV2Language): void => {
  try {
    localStorage.setItem(GCC_V2_LANGUAGE_KEY, lang);
  } catch {
    // ignore storage failures
  }
};

// Appended to every GCC v2 prompt so the model can't leave section headings,
// labels, or any other fragment in the other language — a bare "Respond in
// English"/"الرجاء الرد باللغة العربية" was letting headings slip through
// in the wrong language even when the body matched.
const STRICT_LANGUAGE_INSTRUCTION: Record<GCCV2Language, string> = {
  en: "Respond entirely in English. Every part of your response — headings, labels, and body text alike — must be in English, with no words or phrases in any other language.",
  ar: "الرجاء الرد بالكامل باللغة العربية. يجب أن يكون كل جزء من ردك — العناوين والتسميات والنص الأساسي — باللغة العربية، دون أي كلمات أو عبارات بلغة أخرى.",
};

export const getGCCV2StrictLanguageInstruction = (
  language: GCCV2Language,
): string => STRICT_LANGUAGE_INSTRUCTION[language];
